import React from 'react';
import PropTypes from 'react-proptypes';

import './separator.scss';

const Separator = ({
    color, size, vertical, ...props
}) => {
    const styles = {
        height: vertical ? size : '2px',
        width: vertical ? '2px' : size,
        backgroundColor: color,
    };

    return <hr className="Separator" style={styles} {...props} />;
};

Separator.propTypes = {
    color: PropTypes.string,
    size: PropTypes.string,
    vertical: PropTypes.bool,
};

Separator.defaultProps = {
    color: '#59dcff',
    size: '100%',
    vertical: false,
};

export default Separator;
